/* One script for every buy box: the quantity menu (bs-qty snippet), the option picker (bs-options snippet) and the
   price block (bs-price 'buy' part). A change in the menu updates, inside the nearest [data-bs-buy]: the variant id
   and quantity the form sends, the total, the struck-through compare price, the monthly amount, the 4-payment line,
   the financing example and the savings line. A change in the option picker updates the same hidden id field and
   re-points the quantity menu's options at the newly chosen variant. Financing constants come from window.BS.fin
   (bs-head). */
(function () {
  var fin = (window.BS && window.BS.fin) || { apr: 15, term: 12, disclosure: '' };
  var r = fin.apr / 1200, factor = r / (1 - Math.pow(1 + r, -fin.term));
  var money = function (c) { return '$' + (c / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); };
  var whole = function (c) { return c % 100 === 0 ? '$' + (c / 100).toLocaleString('en-US') : money(c); };

  function paintBox(box, price, compare) {
    var mo = Math.round(price * factor), q = Math.round(price / 4);
    var total = box.querySelector('[data-bs-total]'); if (total) { total.dataset.bsTotal = price; total.textContent = whole(price); }
    var was = box.querySelector('[data-bs-was]'); if (was) { was.hidden = !(compare > price); if (compare > price) was.textContent = whole(compare); }
    box.querySelectorAll('[data-bs-monthly]').forEach(function (m) { m.dataset.bsMonthly = mo; m.dataset.bsPrice = price; m.innerHTML = money(mo) + '<small>/mo</small>'; });
    var four = box.querySelector('[data-bs-four]'); if (four) four.textContent = 'or 4 interest-free payments of ' + money(q);
  }
  /* A preorder buy box (bs-pdp) carries two price blocks: the regular one and the preorder one. Shopify takes the
     selling plan's saving off each unit first and the multi-safe deal (pct) off what's left, so the preorder total is
     the regular total less the per-unit saving after the deal. Each block is painted with its own figure; the financing
     example follows whichever is showing. Every other buy box has one block and paints as before. */
  function paint(scope, price, compare, qty, pct) {
    var reg = scope.querySelector('[data-bs-reg]'), pre = scope.querySelector('[data-bs-pre]'), shown = price;
    if (reg && pre) {
      var prePrice = Math.max(0, Math.round(price - (+pre.dataset.bsPreOff || 0) * (qty || 1) * (100 - (pct || 0)) / 100));
      paintBox(reg, price, compare); paintBox(pre, prePrice, 0);
      if (!pre.hidden) shown = prePrice;
    } else paintBox(scope, price, compare);
    var mo = Math.round(shown * factor), q = Math.round(shown / 4);
    var note = scope.querySelector('[data-bs-fin-example]');
    if (note) note.textContent = 'A ' + whole(shown) + ' purchase could be split into ' + fin.term + ' monthly payments of ' + money(mo) + ' at ' + fin.apr + '% APR, or 4 interest-free payments of ' + money(q) + ' every 2 weeks. ' + fin.disclosure;
  }

  function wire(q) {
    if (q.bsWired) return; q.bsWired = true;
    var scope = q.closest('[data-bs-buy]') || q.closest('form') || q;
    var sel = q.querySelector('select'), idField = q.querySelector('input[name="id"]'), qtyField = q.querySelector('[data-bs-qty-field]');
    var saveLine = q.dataset.saveLine || '', saving = q.querySelector('[data-bs-saving]');
    var bulk = q.querySelector('[data-bs-bulk]');   // 'Bulk discounts on 2 or more': only while 1 is picked
    /* the deal strip joined to the menu (bs-qty, multi-safe deal): names the deal while 1 is picked, then says what the
       chosen quantity saves, after any pre-order saving (the order Shopify applies them, so it matches checkout) */
    var dealLine = q.querySelector('[data-bs-deal-line]'), dealText = dealLine && dealLine.querySelector('[data-bs-deal-text]');
    var dealIntro = dealText ? dealText.innerHTML : '';
    var paintDeal = function (o) {
      if (!dealText) return;
      var pct = +o.dataset.pct || 0, n = +o.dataset.qty || 1;
      dealLine.classList.toggle('is-on', pct > 0);
      if (!pct) { dealText.innerHTML = dealIntro; return; }
      var pre = scope.querySelector('[data-bs-pre]'), off = pre && !pre.hidden ? +pre.dataset.bsPreOff || 0 : 0;
      var total = Math.max(0, Math.round(+o.dataset.price - off * n * (100 - pct) / 100)), full = Math.round(total * 100 / (100 - pct));
      var name = pct === 25 && n < 10 ? dealLine.dataset.name : pct + '% off';
      var b = document.createElement('b'); b.textContent = name + ': you save ' + whole(full - total);
      dealText.textContent = ''; dealText.appendChild(b);
      dealText.appendChild(document.createTextNode(' · ' + whole(Math.round(total / n)) + ' each'));
    };
    var apply = function () {
      var o = sel.options[sel.selectedIndex]; if (!o) return;
      paintDeal(o);
      idField.value = o.dataset.id; qtyField.value = o.dataset.qty || 1;
      paint(scope, +o.dataset.price, +o.dataset.compare || 0, +o.dataset.qty || 1, +o.dataset.pct || 0);
      var save = +o.dataset.saving || 0;
      if (saving) { saving.hidden = !!dealLine || !(save > 0 && saveLine); if (save > 0 && saveLine) saving.textContent = saveLine.replace('[amount]', whole(save)).replace('[percent]', o.dataset.pct + '%').replace('[qty]', o.value); }
      var btn = scope.querySelector('button[name="add"]'); if (btn) btn.disabled = o.disabled;
      if (bulk) bulk.hidden = (+o.value || 1) > 1;
    };
    sel.addEventListener('change', apply);
    scope.addEventListener('bs:preorder', apply);   // bs-pdp.js: the preorder block was shown or hidden
    apply();
  }
  function wireOptions(fs) {
    if (fs.bsWired) return; fs.bsWired = true;
    var scope = fs.closest('[data-bs-buy]') || fs.closest('form') || fs;
    var idField = scope.querySelector('input[name="id"]');
    fs.addEventListener('change', function (e) {
      var radio = e.target; if (radio.tagName !== 'INPUT') return;
      var id = radio.dataset.id; if (!id) return;
      if (idField) idField.value = id;
      // Keep the quantity menu (bs-qty) in sync: every option there points at the pre-color-pick variant.
      var sel = scope.querySelector('.bs-qty-select');
      if (sel) { Array.prototype.forEach.call(sel.options, function (o) { o.dataset.id = id; }); sel.dispatchEvent(new Event('change')); }
      var btn = scope.querySelector('button[name="add"]'); if (btn) btn.disabled = radio.disabled;
    });
  }

  var init = function () {
    document.querySelectorAll('[data-bs-qty]').forEach(wire);
    document.querySelectorAll('[data-bs-options]').forEach(wireOptions);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
